<div class="main_body purpleBack" (window:resize)="onResized($event)" *ngIf="!isDesktop">
  <router-outlet></router-outlet>
  <app-snack-bar></app-snack-bar>
</div>
<app-pwa-desktop *ngIf="isDesktop"></app-pwa-desktop>
<app-rotate-phone-lock *ngIf="!isDesktop"></app-rotate-phone-lock>
